import GarconService from "@/services/GarconService";

export const garcon = {
  namespaced: true,
  state: {
    garcon: {},
  },
  actions: {
    getGarcon({ commit }, payload) {
      return GarconService.GetGarcon(payload).then(
        (garcon) => Promise.resolve(garcon),
        (error) => Promise.reject(error.response.data)
      );
    },
    postGarcon({ commit }, payload) {
      return GarconService.PostGarcon(payload).then(
        (garcon) => Promise.resolve(garcon),
        (error) => Promise.reject(error.response.data)
      );
    },
    putGarcon({ commit }, payload) {
      return GarconService.PutGarcon(payload).then(
        (garcon) => Promise.resolve(garcon),
        (error) => Promise.reject(error.response.data)
      );
    },
    deleteGarcon({ commit }, payload) {
      return GarconService.DeleteGarcon(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    getGarconOData({ commit }, payload) {
      return GarconService.GetGarconOData(payload).then(
        (garcon) => Promise.resolve(garcon),
        (error) => Promise.reject(error)
      );
    },
    validarSenha({ commit }, payload) {
      return GarconService.ValidarSenha(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
  },
  mutations: {},
};

export default garcon;
